import * as React from 'react';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './RoundArrowRight.css';

interface IRoundArrowRightProps {
  onClick(): void;
  topOffset?: number;
}

export const RoundArrowRight: React.FC<IRoundArrowRightProps> = ({ onClick, topOffset }) => {
  const style =
    topOffset !== undefined
      ? {
          top: `${topOffset}px`,
          alignSelf: 'start',
        }
      : undefined;

  return (
    <div className={styles['arrow']} style={style} onClick={onClick}>
      <IconActionChevronRight16 color="icon-secondary-default" />
    </div>
  );
};
